import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isEditing)?_c('span',[_vm._v(_vm._s(_vm.value))]):_c('span',[_c(VTextField,{ref:"editableText",staticClass:"editable-text",attrs:{"value":_vm.value,"outline":"","single-line":"","rules":_vm.rules},on:{"update:value":function($event){_vm.value=$event},"input":_vm.handleInput,"update:error":_vm.handleError}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }